import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Combobox } from "@/components/ui/combobox";
import { ReceiptUploader } from "@/components/ReceiptUploader";
import { MultiPhotoUploader } from "@/components/MultiPhotoUploader";

// Store, date and payment are read by AI after saving; category is always chosen by the person.
export const ExpenseReceiptFields = ({ form, setForm, receipts, onReceiptsChange, noReceipt, onNoReceiptChange,
  vendorOptions, worker = false, showDetails = false }) => {
  const prefix = worker ? "worker-expense" : "expense";
  const skip = checked => {
    onNoReceiptChange(checked);
    onReceiptsChange([]);
    if (!checked) setForm(current => ({ ...current, no_receipt_reason: "" }));
  };
  const required = noReceipt ? " *" : "";
  return (
    <div className="space-y-3" data-testid={`${prefix}-receipt-fields`}>
      {!noReceipt && (worker
        ? <MultiPhotoUploader value={receipts} onChange={onReceiptsChange} label="Receipt photos" testId={`${prefix}-receipt`} max={6} colonyId={form.colony_id || undefined} noLive />
        : <ReceiptUploader value={receipts} onChange={onReceiptsChange} testId={`${prefix}-receipt`} colonyId={form.colony_id || undefined} />)}
      {!noReceipt && receipts.length > 0 && <p className="text-xs text-muted-foreground" role="status" data-testid={`${prefix}-receipt-scan-status`}>
        Store, date, payment method and card last 4 digits are filled in from the receipt right after you save.
      </p>}
      <label className="flex items-center gap-2 text-sm cursor-pointer" data-testid={worker ? "worker-expense-noreceipt-toggle" : "expense-no-receipt-row"}>
        <input type="checkbox" checked={noReceipt} onChange={event => skip(event.target.checked)} data-testid={worker ? "worker-expense-noreceipt-checkbox" : "expense-no-receipt-toggle"} />
        Skip receipt — I’ll explain why
      </label>
      {noReceipt && <div>
        <Label htmlFor={`${prefix}-missing-receipt`}>Why don’t you have the receipt? *</Label>
        <Textarea id={`${prefix}-missing-receipt`} rows={2} value={form.no_receipt_reason} onChange={event => setForm(current => ({ ...current, no_receipt_reason: event.target.value }))} data-testid={worker ? "worker-expense-noreceipt" : "expense-no-receipt-reason"} />
      </div>}
      {(noReceipt || showDetails) && <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid={`${prefix}-manual-receipt-details`}>
        <div><Label>Store / vendor{required}</Label><Combobox value={form.vendor} onChange={vendor => setForm(current => ({ ...current, vendor }))} options={vendorOptions} placeholder="Store name…" testId={`${prefix}-vendor`} /></div>
        <div><Label>Date{required}</Label><Input type="date" value={form.date} onChange={event => setForm(current => ({ ...current, date: event.target.value }))} data-testid={`${prefix}-date`} /></div>
      </div>}
    </div>
  );
};
